import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

export interface ProductData {id?:string, text:string, path:string, mainPath:string, active?:boolean};

@Injectable()
export class ProductRouteInfoService{

    productsMappping: Array<ProductData> = [
      {id:"RateAudit", text: 'Rate Audit', path:"main/rateAudit/monitor", mainPath: "/main/rateAudit"},
      {id:"RateAvailability", text: 'Rate Availability', path:"main/rateAvailability/monitor", mainPath: "/main/rateAvailability"},
      {id:"ReverseAudit", text: 'Reverse Audit', path:"main/reverseAudit/monitor", mainPath: "/main/reverseAudit"}
    ]
    reportsMapping: Array<ProductData> = [
      {id:"RateAudit", text: 'Rate Audit Notification Editor', path:'notifications/editor/rate-audit', mainPath: '/notifications/editor/rate-audit'},
      {id:"RateAvailability", text: 'Rate Availability Notification Editor', path:'notifications/editor/rate-availability', mainPath: '/notifications/editor/rate-availability'},
      {id:"ReverseAudit", text: 'Reverse Audit Notification Editor', path:'notifications/editor/reverse-audit', mainPath: '/notifications/editor/reverse-audit'}
    ];
    public Get(productAccess: string[]) : ProductData[]
    {
      return this.FilterDropdown(productAccess, this.productsMappping);
    }
    public GetReports(productAccess: string[]) : ProductData[]
    {
      return this.FilterDropdown(productAccess, this.reportsMapping);
    }
    public FilterDropdown(productAccess: string[], list:Array<ProductData>) : ProductData[]
    {
      var productList = ['RateAudit','RateAvailability','ReverseAudit'];
      return JSON.parse(JSON.stringify( productAccess.filter(q => productList.includes(q)).map( s => list.find( r => r.id === s ) )));//clone
    }
    public GetHighestPriorityProduct(productAccess: string[]) : ProductData
    {
      var list = this.Get(productAccess);
      if (list.length>0) {
        return list[0];
      }
      return null;
    }
    public NavigateToHighestPriorityProduct(productAccess: string[], router:Router){
      let nxt = this.GetHighestPriorityProduct(productAccess);
      let nxtRoute=null;
      let current =  router.routerState.snapshot.url;
      if (nxt) {
        nxtRoute = nxt.path;
      }
      else{
        nxtRoute = "main";
      }
      if (nxtRoute && current != ("/" +nxtRoute)) {
          router.navigate([ nxtRoute]);
      }
    }

}

